module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-1.6e6a959e.webp";